import styles from './Button.module.css';

import type { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variant?: 'primary' | 'secondary' | 'ghost';
  /** Em andamento. Desabilita e anuncia o estado. */
  readonly loading?: boolean;
  readonly children: ReactNode;
}

/**
 * Botão do design system.
 *
 * <p>
 * O estado de carregamento é anunciado por <code>aria-busy</code> e por texto,
 * não só por um spinner: um ícone girando não diz nada a quem usa leitor de
 * tela (docs/22 §7).
 * </p>
 * <p>
 * <code>type</code> tem padrão <code>button</code> de propósito. O padrão do
 * HTML é <code>submit</code>, e um botão auxiliar dentro de um formulário
 * acabaria enviando-o — defeito que só aparece quando alguém aperta Enter.
 * </p>
 */
export function Button({
  variant = 'primary',
  loading = false,
  disabled,
  children,
  type = 'button',
  ...rest
}: ButtonProps): JSX.Element {
  return (
    <button
      {...rest}
      aria-busy={loading}
      className={`${styles.button} ${styles[variant]}`}
      disabled={disabled === true || loading}
      type={type}
    >
      {loading ? (
        <>
          <span aria-hidden="true" className={styles.spinner} />
          <span>Aguarde…</span>
        </>
      ) : (
        children
      )}
    </button>
  );
}
